import Verify from '@components/pages/verify';

export default Verify;
